import React, { useCallback, useRef, useState } from 'react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

/* ═══════════════════════════════════════════════════════════════════════════
   HUPALUPA STORE — EKİM 2026 MARKA BÜTÇESİ                         ₺500.000
   ---------------------------------------------------------------------------
   7 Ekim 2026. Markadan gelen toplam ₺500.000; dağılım bizim.
   Eylül tam ay ₺1.097.132 harcadı → Ekim −%54.

   🔑 Efe'nin istekleri (7 Eki, sırayla):
     · NeeDoh (stok yok) ve Smiggle (okul dönemi bitti) bütçe ALMAZ; 70K'ları
       "Diğer marka siloları"na.
     · Store katalog motoru sayfada açıklansın.
     · Ekim gerçekleşeni (harcanan / kalan / günlük tempo) GÖSTERİLMEZ.
     · Store katalog motoru + Diğer marka siloları TEK "Diğer ürünler"
       kalemi (Eylül: 278.923 + 71.442 = 350.365).
     · Eylül / ciro / değişim / plan sütunları YOK — yalnız bütçe dağılımı
       (eyl ve plan alanları veride duruyor, ekranda kullanılmıyor).
     · Grup kırılımı YOK (lansman / motor / satan / küçük diye bölme) —
       tek düz liste, bütçeye göre sıralı, derli toplu.

   🔑 Eylül rakamları DONDURULMUŞ. Kaynak `/api/hupalupa/brand-ledger`
   (Overview2 "Marka Bazlı Harcama ve Ciro" ile aynı uç ve eşleşme). Dip
   toplamlar ham kampanya toplamına birebir oturuyor.
   🔴 Ciro GA4 `itemBrand` — reklam atfı DEĞİL, "ciro / harcama" ROAS değil.

   Bütçe değiştirmek için yalnız KALEMLER[].google / .meta; her toplam oradan
   türetiliyor. ₺500.000'den saparsa üstte kırmızı uyarı çıkar.
   ═══════════════════════════════════════════════════════════════════════════ */

const TOPLAM_HEDEF = 500000;


/* google / meta : Ekim bütçesi · eyl : Eylül harcama (h) ve GA4 ciro (c) */
const KALEMLER = [
  { key: 'diger', ad: 'Diğer ürünler', rozet: 'Diğer',
    google: 70000, meta: 80000, eyl: { h: 350365, c: 794557 },
    plan: 'Store kataloğu, genel arama, gönderi öne çıkarma tek kalemde; küçük markalar katalogdan satar. Kırtasiye kataloğu durur; Our Generation ve Connetix kapanır.' },
  { key: 'playmobil', ad: 'Playmobil', logo: '/logos/markalar/playmobil.svg',
    google: 45000, meta: 75000, eyl: { h: 121442, c: 32146 },
    plan: 'Lansman önceliği. Katalog içinde ürün seti olarak; ay ortasında yeniden bakılır.' },
  { key: 'numberblocks', ad: 'Numberblocks', rozet: 'NB',
    google: 40000, meta: 70000, eyl: { h: 0, c: 0 },
    plan: 'Lansman önceliği; ₺50K Diğer ürünlerden aktarıldı. Ekim’de reklamsız satmaya başladı.' },
  { key: 'modu', ad: 'Modu', rozet: 'Modu',
    google: 25000, meta: 25000, eyl: { h: 26930, c: 94180 },
    plan: 'Eylül’ün en verimli silosu; ₺20K Diğer ürünlerden aktarıldı.' },
  { key: 'zoo', ad: 'The Zoo Family', logo: '/logos/markalar/zoofamily.svg',
    google: 15000, meta: 5000, eyl: { h: 27971, c: 41712 },
    plan: 'Ağırlık Google’da kalıyor.' },
  { key: 'antonio', ad: 'Antonio Juan', logo: '/logos/markalar/antoniojuan.png',
    google: 5000, meta: 15000, eyl: { h: 34605, c: 29405 },
    plan: 'Meta katalog setinde düşük seviye; yılbaşında büyür.' },
  { key: 'xmud', ad: 'X Mud', logo: '/logos/markalar/xmud.png',
    google: 5000, meta: 10000, eyl: { h: 60425, c: 27772 },
    plan: '"slime" aramasına Search, Meta’da kısıldı.' },
  { key: 'charmit', ad: 'Charm It', logo: '/logos/markalar/charmit.png',
    google: 0, meta: 10000, eyl: { h: 24029, c: 7029 },
    plan: 'Yalnız Meta, remarketing ağırlıklı.' },
  { key: 'meli', ad: 'Meli', rozet: 'Meli',
    google: 5000, meta: 0, eyl: { h: 3003, c: 3798 },
    plan: 'Yalnız Google, aynı seviye.' },
  { key: 'needoh', ad: 'NeeDoh', logo: '/logos/markalar/needoh.svg',
    google: 0, meta: 0, eyl: { h: 407572, c: 1273366 },
    plan: 'Stok yok (feed’de 2 ürün). Stok gelirse Diğer’den pay açılır.' },
  { key: 'smiggle', ad: 'Smiggle', rozet: 'Smiggle',
    google: 0, meta: 0, eyl: { h: 40790, c: 115665 },
    plan: 'Okul dönemi bitti, bu ay kapalı.' },
];

/* "Diğer ürünler"in içi — brand-ledger'ın "Markaya ayrılmayan" düğümleri
   kampanya adına göre ayrıldı + küçük marka siloları; Eylül 350.365'e birebir. */
const DIGER_PARCALAR = [
  { ad: 'Katalog reklamları', ekim: 105000, eyl: 155225 + 71442,
    ne: 'Meta Advantage+ katalog ve Google Performance Max “Tüm Ürünler” + Shopping. Feed’deki tüm ürünleri kullanır; hangi ürünün kime gösterileceğini platform seçer.' },
  { ad: 'Genel arama', ekim: 35000, eyl: 77345,
    ne: 'Dinamik arama reklamları (DSA), “hupalupa” arayanlara marka reklamı, genel okul ihtiyaçları araması.' },
  { ad: 'Gönderi öne çıkarma', ekim: 10000, eyl: 41039,
    ne: 'Instagram gönderi reklamları ve TikTok takipçi kampanyası. Satış değil görünürlük.' },
  { ad: 'Eylül’de kapanan kalemler', ekim: 0, eyl: 5314,
    ne: 'Eylül’de açılıp kapanan küçük kampanyalar.' },
];

/* ── Yardımcılar ─────────────────────────────────────────────────────────── */
const tl = (v) => (v < 0 ? '−' : '') + '₺' + Math.abs(Math.round(v)).toLocaleString('tr-TR');
const butce = (k) => k.google + k.meta;
const topla = (arr, f) => arr.reduce((a, x) => a + f(x), 0);

const SIRALI = [...KALEMLER].sort((a, b) => butce(b) - butce(a));
const TOPLAM = topla(KALEMLER, butce);
const TOPLAM_GOOGLE = topla(KALEMLER, (k) => k.google);
const TOPLAM_META = topla(KALEMLER, (k) => k.meta);

const HUE = '#2a78d6';

function Logo({ kalem }) {
  return (
    <div className="h-8 w-16 shrink-0 rounded-md border border-gray-200 bg-white flex items-center justify-center overflow-hidden">
      {kalem.logo
        ? <img src={kalem.logo} alt="" className="max-h-6 max-w-[54px] object-contain" />
        : <span className="text-[10px] font-bold text-gray-600 tracking-tight">{kalem.rozet}</span>}
    </div>
  );
}

function Kart({ baslik, deger, alt, vurgu }) {
  return (
    <div className={`rounded-xl border p-4 ${vurgu ? 'bg-gray-900 border-gray-900' : 'bg-white border-gray-200'}`}>
      <div className={`text-[11px] font-medium ${vurgu ? 'text-gray-300' : 'text-gray-500'}`}>{baslik}</div>
      <div className={`text-2xl font-bold mt-1 tabular-nums ${vurgu ? 'text-white' : 'text-gray-900'}`}>{deger}</div>
      <div className={`text-[11px] mt-1 ${vurgu ? 'text-gray-300' : 'text-gray-500'}`}>{alt}</div>
    </div>
  );
}

const pay = (v) => '%' + Math.round((v / TOPLAM) * 100);

export default function HupalupaStoreEkim2026MarkaButcesi() {
  const maks = Math.max(...KALEMLER.map(butce));
  const sayfaRef = useRef(null);
  const [indiriliyor, setIndiriliyor] = useState(false);

  // Tek A4: sayfanın tamamı tek görüntü, genişliğe (taşarsa yüksekliğe) sığdırılır.
  const pdfIndir = useCallback(async () => {
    if (indiriliyor || !sayfaRef.current) return;
    setIndiriliyor(true);
    try {
      const el = sayfaRef.current;
      const canvas = await html2canvas(el, {
        scale: 2, backgroundColor: '#ffffff', useCORS: true,
        width: el.offsetWidth, height: el.scrollHeight,
        windowWidth: document.documentElement.clientWidth,
        // Tailwind preflight img{display:block} html2canvas'ta metni aşağı kaydırıyor.
        onclone: (doc) => {
          const st = doc.createElement('style');
          st.textContent = 'img{display:inline-block !important}';
          doc.head.appendChild(st);
        },
      });
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pw = pdf.internal.pageSize.getWidth();
      const ph = pdf.internal.pageSize.getHeight();
      const M = 10;
      let w = pw - 2 * M;
      let h = (canvas.height / canvas.width) * w;
      if (h > ph - 2 * M) { h = ph - 2 * M; w = (canvas.width / canvas.height) * h; }
      pdf.addImage(canvas.toDataURL('image/jpeg', 0.95), 'JPEG', (pw - w) / 2, M, w, h);
      pdf.save('Hupalupa_Store_Ekim_2026_Marka_Butcesi.pdf');
    } catch (e) {
      console.error('PDF export failed:', e);
    } finally {
      setIndiriliyor(false);
    }
  }, [indiriliyor]);

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <div className="flex justify-end mb-3">
        <button
          onClick={pdfIndir}
          disabled={indiriliyor}
          className="bg-gray-900 hover:bg-gray-800 text-white text-sm font-semibold px-4 py-2 rounded-lg shadow-sm disabled:opacity-60"
        >
          {indiriliyor ? 'PDF hazırlanıyor…' : 'PDF olarak indir'}
        </button>
      </div>
      <div ref={sayfaRef} className="bg-white rounded-2xl shadow-sm border overflow-hidden">

        {/* ── Başlık ── */}
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <img src="/logos/markalar/hupalupastore.svg" alt="Hupalupa Store" className="h-8 w-auto object-contain" />
            <div>
              <h2 className="text-lg font-bold text-gray-800">HUPALUPA STORE — Ekim 2026 Marka Bütçesi</h2>
              <p className="text-sm text-gray-500">Marka ve kanal dağılımı</p>
            </div>
          </div>
          <span className="inline-block h-8 leading-8 px-3 bg-gray-800 text-white text-sm font-semibold rounded-full self-start sm:self-auto whitespace-nowrap">
            Toplam: {tl(TOPLAM)}
          </span>
        </div>

        <div className="p-6">

          {TOPLAM !== TOPLAM_HEDEF && (
            <div className="mb-6 p-4 rounded-xl bg-red-100 border border-red-300 text-[12px] text-red-900">
              <strong>Dip toplam tutmuyor:</strong> kalemlerin toplamı {tl(TOPLAM)}, markanın verdiği {tl(TOPLAM_HEDEF)}.
            </div>
          )}

          {/* ── Kartlar ── */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-5">
            <Kart vurgu baslik="Ekim bütçesi" deger={tl(TOPLAM)} alt="1–31 Ekim 2026" />
            <Kart baslik="Google" deger={tl(TOPLAM_GOOGLE)} alt={`Bütçe payı ${pay(TOPLAM_GOOGLE)}`} />
            <Kart baslik="Meta" deger={tl(TOPLAM_META)} alt={`Bütçe payı ${pay(TOPLAM_META)}`} />
          </div>

          {/* ── Dağılım ── */}
          <div className="overflow-x-auto rounded-xl border border-gray-200 mb-6">
            <table className="w-full text-[12.5px]">
              <thead>
                <tr className="bg-gray-50 text-gray-500 text-[11px] uppercase tracking-wide">
                  <th className="text-left font-semibold px-4 py-2.5">Kalem</th>
                  <th className="text-right font-semibold px-3 py-2.5 w-56 whitespace-nowrap">Ekim bütçesi</th>
                  <th className="text-right font-semibold px-3 py-2.5">Pay</th>
                  <th className="text-right font-semibold px-3 py-2.5">Google</th>
                  <th className="text-right font-semibold px-4 py-2.5">Meta</th>
                </tr>
              </thead>
              <tbody>
                {SIRALI.map((k) => {
                  const b = butce(k);
                  return (
                    <tr key={k.key} className={`border-t border-gray-100 ${b === 0 ? 'bg-gray-50/70 text-gray-400' : ''}`}>
                      <td className="px-4 py-2.5">
                        <div className={`flex items-center gap-3 ${b === 0 ? 'opacity-60' : ''}`}>
                          <Logo kalem={k} />
                          <span className="font-semibold text-gray-800 whitespace-nowrap">{k.ad}</span>
                        </div>
                      </td>
                      <td className="px-3 py-2.5 text-right">
                        <div className={`font-bold tabular-nums ${b === 0 ? 'text-gray-400' : 'text-gray-900'}`}>{b === 0 ? 'Kapalı' : tl(b)}</div>
                        {b > 0 && (
                          <div className="h-1.5 w-full rounded-full bg-gray-100 mt-1">
                            <div className="h-1.5 rounded-full" style={{ width: `${Math.max(3, (b / maks) * 100)}%`, background: HUE }} />
                          </div>
                        )}
                      </td>
                      <td className="px-3 py-2.5 text-right tabular-nums text-gray-500">{b ? pay(b) : '—'}</td>
                      <td className="px-3 py-2.5 text-right tabular-nums text-gray-700">{k.google ? tl(k.google) : '—'}</td>
                      <td className="px-4 py-2.5 text-right tabular-nums text-gray-700">{k.meta ? tl(k.meta) : '—'}</td>
                    </tr>
                  );
                })}
                <tr className="border-t-2 border-gray-800 bg-gray-50 font-semibold">
                  <td className="px-4 py-2.5 text-gray-900">Toplam</td>
                  <td className="px-3 py-2.5 text-right font-bold tabular-nums text-gray-900">{tl(TOPLAM)}</td>
                  <td className="px-3 py-2.5 text-right tabular-nums">%100</td>
                  <td className="px-3 py-2.5 text-right tabular-nums">{tl(TOPLAM_GOOGLE)}</td>
                  <td className="px-4 py-2.5 text-right tabular-nums">{tl(TOPLAM_META)}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* ── Diğer ürünler neyi kapsıyor ── */}
          <div className="rounded-xl border border-gray-200 overflow-hidden">
            <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
              <h3 className="text-sm font-bold text-gray-800">Diğer ürünler neyi kapsıyor?</h3>
              <p className="text-[11.5px] text-gray-600 leading-relaxed mt-1">
                Tabloda kendi satırı olan markalar dışındaki her şey: <strong>mağazanın tamamını</strong> satan katalog ve arama kampanyaları.
              </p>
            </div>
            <table className="w-full text-[12px]">
              <tbody>
                {DIGER_PARCALAR.filter((m) => m.ekim).map((m) => (
                  <tr key={m.ad} className="border-t border-gray-100 first:border-t-0 align-top">
                    <td className="px-4 py-2.5 font-semibold text-gray-800 whitespace-nowrap">{m.ad}</td>
                    <td className="px-3 py-2.5 text-[11.5px] text-gray-600 leading-snug">{m.ne}</td>
                    <td className="px-4 py-2.5 text-right tabular-nums font-bold text-gray-900 whitespace-nowrap">{tl(m.ekim)}</td>
                  </tr>
                ))}
                <tr className="border-t-2 border-gray-800 bg-gray-50 font-semibold">
                  <td className="px-4 py-2.5" colSpan={2}>Toplam</td>
                  <td className="px-4 py-2.5 text-right tabular-nums">{tl(topla(DIGER_PARCALAR, (m) => m.ekim))}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
